export default __webpack_public_path__ + "static/media/envelope-bold.15ca4ca1.svg";